export enum AttributeItemType {
  OBJECT = "object",
  USER = "user",
  EXTERNAL_APPLICATION = "external_application",
}
